/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function initialise() {
  if (!hasSeenAcknowledgmentToday()) {
    showAcknowledgment()
  }
}

function hasSeenAcknowledgmentToday() {
  const localValue = window.localStorage.getItem('acknowledgment')
  return localValue && isSameDay(new Date(localValue), new Date())
}

function showAcknowledgment() {
  $('[data-acknowledgment]')
    .addClass('open')
    .delay(4500)
    .fadeOut()

  $('[data-acknowledgment]').on('click', () => {
    $('[data-acknowledgment]').dequeue()
  })

  window.localStorage.setItem('acknowledgment', new Date())
}

function isSameDay(date1, date2) {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  )
}
